import '@sass/_results.scss';
import { EventDispatcher, copyToClipboard, gebi, genUID, getTimeText, getUrlVars, isMobileView, isSafari, l, lLink, lc, logEvent, qs, setUrlParameter, shareClick, urlParameterDelete } from '@utils/toolbox';
import { dateFormat, dateParseISO } from '@utils/dateFns';
import { eventCategories, events } from '@js/utils/event';
import { renderJourneys, renderResultAgents } from '@components/resultsRenderTemplate';
import { Base64 } from '@js/plugins/base64';
import { ErrorTracker } from '@utils/errorTracker';
import { Modal } from '@components/modal';
import { favouriteStatus } from './resultsRenderHelpers';
import { renderModal } from '@components/resultsRenderModalTemplate';
import { toaster } from '@js/components/toast';
import { trackEvent } from '@utils/googleDataLayer';
import { useResultQueryStore } from '@/src/vue/components/Filters/store/resultQueryStore';

const resultQueryStore = useResultQueryStore();

export const resultsRender = {
	initialised: false,
	elems: {
		sharedResultContainer: gebi('shared-result-container'),
		sharedResultInnerContainer: qs('#shared-result-container .sharedResult'),
		sharedResultCloseBtn: qs('#shared-result-container .sharedResult__closeBtn'),
		sharedResult: qs('#shared-result-container .sharedResult__result')
	},
	response: resultQueryStore.state.response,
	searchParams: {
		filters: {}
	},
	isMultiCitySearch: js_params?.returntrip === 2,
	isYouthSearch: !!js_params?.isYouthSearch,
	isSharedResultView: typeof js_params?.sharedOrgIndex === 'number',
	missingResultDetails: {
		aircraftTypes: [],
		airlines: [],
		airports: []
	},
	missingResultDetailsTrackers: {
		/**
		 * @type {ErrorTracker}
		 */
		aircraftTypes: new ErrorTracker(),
		/**
		 * @type {ErrorTracker}
		 */
		airlines: new ErrorTracker(),
		/**
		 * @type {ErrorTracker}
		 */
		airports: new ErrorTracker()
	},
	// passengers count excluding infants
	// TODO: Do we need to include youthTickets here?
	// numberOfBags: (js_params?.passengers || 0) - js_params?.childrenAges?.filter?.(age => parseInt(age) === 0)?.length || 0,
	get numberOfBags () {
		if (window?.searchBox?.data?.passengers?.child?.ages) {
			const numberOfChildrenOver1 = window.searchBox.data.passengers.child.ages.filter(age => age > 1).length;
			return searchBox.data.passengers.adults + numberOfChildrenOver1;
		}
		return js_params?.passengers - js_params?.childrenAges?.filter?.(age => parseInt(age) === 0)?.length || 0;
	},
	get isBaggageIncludedFiltered () {
		return Boolean(this.searchParams?.filters?.baggageIncluded);
	},
	get isFlexTicketFiltered () {
		return Boolean(this.searchParams?.filters?.flexTicket);
	},
	get isCabinBaggageIncludedFiltered () {
		return Boolean(this.searchParams?.filters?.cabinBaggageIncluded);
	},
	get isClimateCompensatedFiltered () {
		return Boolean(this.searchParams?.filters?.climateCompensated);
	},
	get isEmissionSorting () {
		return this.searchParams.sorting === 'emission';
	},
	get isYouthFiltered () {
		return Boolean(this.searchParams?.filters?.youthTicket);
	},
	bindEvents () {
		// Disable browser back button when result modal is open on mobile
		if (typeof window.history !== 'undefined' && this.isMobile) {
			// history.pushState(null, null, document.URL);

			window.addEventListener('popstate', () => {
				if (this.resultModal?.isOpen) {
					this.resultModal.close();

					// history.pushState(null, null, document.URL);
				}
			});
		}

		// If the url contains a shared
		if (this.isSharedResultView) {
			document.body.classList.add('shared-result');
		}

		if (this.elems.sharedResultCloseBtn) {
			this.elems.sharedResultCloseBtn.addEventListener('click', this.removeSharedResult.bind(this));
		}

		document.addEventListener('click', (event) => {
			/* eslint-disable no-useless-return */
			const elem = event.target;
			// Share button
			if (elem.closest('.copyUrl')) {
				const sharedUrlInput = elem.closest('.shareBtn--manualCopy')?.querySelector('.sharedUrl__field');
				if (sharedUrlInput) {
					sharedUrlInput.select();
					document.execCommand('copy');
					sharedUrlInput.classList.add('copied');
				}

				logEvent(events.shareResult, eventCategories.share);

				return;
			} else if (elem.closest('.shareBtn--manualCopy')) {
				return;
			} else if (elem.closest('.abResult__shareBtn')) { // Closest elem .abResult__shareBtn
				const shareBtn = elem.closest('.abResult__shareBtn');

				const sharedResultURL = this.getSharedResultURL(shareBtn.dataset.result);

				shareClick({ title: js_params.domain_title, url: sharedResultURL }).catch((error) => {
					if (error.name === 'AbortError') {
						return;
					}
					copyToClipboard(sharedResultURL).then(() => {
						console.log('copytoclipboard toast new');
						toaster.newToast(l('showresult.share.linkCopied'), 'info', 'top');
					}).catch((error) => {
						console.log('Clipboard copy failed: ', error);
						this.openManualCopyPopup(shareBtn, sharedResultURL);
					});
				});

				logEvent(events.shareResult, eventCategories.share);

				return;
			}

			// Any tooltip
			if (elem.closest('.icon-circle-question-mark:not(.abIataTimespan__time--decoration--icon)')) {
				event.stopPropagation();
				event.preventDefault();

				if (elem.closest('.icon-circle-question-mark').parentElement.querySelector('.question-mark--text')) {
					if (elem.closest('.icon-circle-question-mark').parentElement.querySelector('.active')) {
						elem.closest('.icon-circle-question-mark').parentElement.querySelector('.question-mark--text').classList.remove('active');
					} else {
						elem.closest('.icon-circle-question-mark').parentElement.querySelector('.question-mark--text').classList.add('active');
					}
				}

				return;
			}

			// Buy button
			if (elem.classList.contains('otaLink')) {
				const source = elem.closest('.abResult--modal') ? 'modal' : new URL(elem.href).searchParams.get('source');
				// Get source from link url parameter

				// Prevent the default action
				// event.preventDefault();

				// Update the url to include the eventId
				const url = new URL(elem.href);
				const eventId = genUID();
				url.searchParams.set('eventId', eventId);

				// Get the index of the result
				const index = elem.closest('.abResult').dataset.index;

				if (source === 'modal') {
					logEvent(events.clickoutResultViewMore, eventCategories.clickout, resultsRender.response.flights[index]);
				} else {
					logEvent(events.clickoutResultList, eventCategories.clickout, resultsRender.response.flights[index]);
				}

				// Send the event to the server
				this.outclickAgencyResult(resultsRender.response.flights[index], index, eventId);
				// window.open(url.href, '_blank');
				return;
			}

			// Buy buttton
			if (elem.closest('.abBuyBtn')) {
				event.stopPropagation();
				return;
			}

			if (elem.closest('.abResult__emission')) {
				event.stopPropagation();
				return;
			}

			// Show all quotes
			if (elem.closest('[data-action="view-all-agencies"]')) {
				const clickedResult = elem.closest('.abResult');
				const otas = qs('.abResult__otaAndBuyAll', clickedResult);
				const icon = qs('.showAllAgencies span', clickedResult);

				const isOtasVisible = otas.classList.contains('abResult__otaAndBuyAll--expanded');

				if (isOtasVisible) {
					otas.classList.remove('abResult__otaAndBuyAll--expanded');
					icon.classList.replace('icon-chevron-up', 'icon-chevron-down');

					otas.innerHTML = '';

					logEvent(events.viewlessOTAs, eventCategories.viewmore, window?.showresult?.activeView);
				} else {
					const resultIndex = Number(clickedResult.dataset.index);
					const agents = [...resultsRender.response.flights[resultIndex].agents];


					const source = window?.showresult?.activeView || 'list';

					otas.innerHTML = renderResultAgents({
						resultIndex: resultIndex,
						agents: agents,
						promotedAgent: resultsRender.response.flights[resultIndex].promotedAgent,
						hasPromotedAgent: 'promotedAgent' in resultsRender.response.flights[resultIndex] && 'promotedProduct' in resultsRender.response.flights[resultIndex],
						extended: true,
						source: source
					});

					icon.classList.replace('icon-chevron-down', 'icon-chevron-up');
					otas.classList.add('abResult__otaAndBuyAll--expanded');

					logEvent(events.viewmoreOTAs, eventCategories.viewmore, window?.showresult?.activeView);
				}

				// eslint-disable-next-line no-useless-return
				return;
			}

			// Trip details toggle
			if (elem.closest('[data-action="toggle-trip-details"]') || elem.closest('.abResult:not(.abResult--modal)')) {
				if (elem.closest('.abResult__flightFavBtn')) {
					return;
				}

				if (elem.classList.contains('abResult__otaAndBuyPreview') && js_params.searchDateIsTooOld) {
					return;
				}

				const clickedResult = elem.closest('.abResult');

				// If click is on the favourites page
				if (js_params.controllerClass == 'page\\favorite') {
					const index = Number(clickedResult.dataset.index);
					const flight = resultsRender.response.flights[index];
					const className = favouriteStatus(flight) + ' modal--resultModal';
					this.renderModal(flight.favouriteMeta.responseId, flight, index, flight.favouriteMeta.filters, { className }, {}, 'favourites').open();
					return;
				}

				if (!isMobileView() && clickedResult.classList.contains('abResult--expanded')) {
					clickedResult.classList.remove('abResult--expanded');

					if (this.resultModal && this.resultModal.isOpen) {
						this.resultModal.close();
					}

					logEvent(events.viewlessResult, eventCategories.viewmore);
				} else {
					resultsRender.toggleTripDetails(clickedResult);

					logEvent(events.viewmoreResult, eventCategories.viewmore);
				}

				return;
			}
		},
		false
		);
		/* eslint-enable no-useless-return */
	},
	/**
	 *
	 * @param {String} template html string to display in the modal
	 * @param {Number} index Index of the result
	 * @returns {Object} a new instance of Modal
	 */
	buildResultModal (template, index) {
		const footer = `
<button class="abResult__shareBtn abBtn abBtn--flex" data-result="${index}">
	<div class="shareBtn__popup"></div>
	<span class="icon icon-share-2"></span>
	<span>${l('global.simplePhrases.share')}</span>
</button>
<button class="js-close-modal abBtn abBtn--flex abBtn--blueWhite">
	<span>${l('global.simplePhrases.close')}</span>
</button>
		`;

		const resizeEvent = (e) => {
			if (isMobileView()) {
				this.resultModal.html.style.display = '';
				document.body.classList.add('modal-open');
			} else {
				this.resultModal.html.style.display = 'none';
				document.body.classList.remove('modal-open');
			}
		};

		this.resultModal = new Modal({
			body: template,
			className: 'modal--resultModal',
			footer: footer,
			hideHeader: true,
			hideMobileUp: true,
			hideOnSwipe: true,
			hideOnHistoryBack: isMobileView(),
			id: 'resultModal',
			onClose: () => {
				// Remove custom event listener.
				window.removeEventListener('resize', resizeEvent);
				this.resultModal = null;
			},
			onInit: () => window.addEventListener('resize', resizeEvent),
			resetScroll: true
		});

		return this.resultModal;
	},
	/**
	 * Lookup airline
	 * @param {String} flightCode - Example: EN
	 * @returns {String} Airline
	 */
	getAirline (flightCode) {
		const airlineCode = flightCode.substr(0, 2);
		const airline = resultsRender.response?.airlineDetails?.[airlineCode] || l('showresult.result.unspecifiedAirline');

		if (
			js_params?.missingDetailsReport
			&& resultsRender.response.airlineDetails
			&& !resultsRender.response.airlineDetails[airlineCode]
			&& !resultsRender.missingResultDetails.airlines.includes(airlineCode)
		) {
			resultsRender.missingResultDetails.airlines.push(airlineCode);
			console.warn(`Unknown airline: ${airlineCode}`);
			this.missingResultDetailsTrackers.airlines.reportError(new Error(`Unknown airline: ${airlineCode}`));
		}

		return airline;
	},
	/**
	 * Lookup airport
	 * @param {String} iata
	 * @returns {airportDetails}
	 */
	getAirport (iata) {
		const airport = resultsRender.response?.airportDetails?.[iata] || '';

		if (
			js_params?.missingDetailsReport
			&& resultsRender.response.airportDetails
			&& !resultsRender.response.airportDetails[iata]
			&& !resultsRender.missingResultDetails.airports.includes(iata)
		) {
			resultsRender.missingResultDetails.airports.push(iata);
			console.warn(`Unknown airport: ${iata}`);
			this.missingResultDetailsTrackers.airports.reportError(new Error(`Unknown airport: ${iata}`));
		}

		return airport;
	},
	/**
	 * @param {Object} flight
	 * @param {Number} tripIndex
	 * @param {Number} alternativeIndex
	 * @param {Object} [options = {}]
	 * @returns {Object}
	 */
	getAlternative (trip, tripIndex, alternativeIndex, options = {}) {
		const longestSegment = {
			traveltime: trip.segments?.[0].traveltime,
			flight: trip.segments?.[0].flight
		};
		const tripWithMeta = {
			...options
		};


		const getWaitingTimeStatus = (trip, segmentId) => {
			let status = 'ok';
			if (trip?.longWaitingTime?.includes?.(segmentId)) {
				status = 'long';
			} else if (trip?.shortWaitingTime?.includes?.(segmentId)) {
				status = 'short';
			}
			return status;
		};

		const flightWaitingStops = [];
		let flightStopsCount = 0;
		let currentTimeOfFlight = 0;
		let tripText = '';
		let waitingTimeStatus = 'ok';
		let requiresAirportChange = 0;

		const noOfSegs = trip.segments.length;

		tripWithMeta.bound = tripIndex === 0 ? 'outbound' : 'inbound';
		tripWithMeta.totalTravelTime = getTimeText(trip.traveltime);
		tripWithMeta.segment = [];
		tripWithMeta.hash = trip.hash;
		let totalWaitingTime = 0;

		for (let i = 0; i < noOfSegs; ++i) {
			const completeSegment = trip.segments[i];

			if (completeSegment) {
				const segment = {
					equipment: completeSegment.equipment,
					airline: this.getAirline(completeSegment.flight),
					arrivalAirport: completeSegment.arrivalAirport,
					arrivalCity: this?.response?.meta?.to || js_params?.to?.city,
					arrivalAirportName: this.getAirport(completeSegment.arrivalAirport).airport,
					arrivalDate: completeSegment.arrivalDate,
					arrivalTime: this.getDisplayTime(completeSegment.arrivalDate),
					cabin: completeSegment.cabin,
					departureAirport: completeSegment.departureAirport,
					departureCity: this?.response?.meta?.from || js_params?.from?.city,
					departureAirportName: this.getAirport(completeSegment.departureAirport).airport,
					departureDate: completeSegment.departureDate,
					departureTime: this.getDisplayTime(completeSegment.departureDate),
					flightNo: completeSegment.flight,
					flightTime: getTimeText(completeSegment.traveltime),
					waitingTimeStatus: getWaitingTimeStatus(trip, completeSegment.id),
					unmetClassType: completeSegment.unmetClassType ? 1 : 0
				};

				// Checks if the segment id is irregular (used in pricecalendar, ex: 878342350_31)
				if (/^\d+_\d+$/.test(completeSegment.id)) {
					let realId = completeSegment.id.split('_');
					realId = realId[realId.length - 1];

					segment.requiresAirportChange = trip?.changeOfAirport?.includes(parseInt(realId)) ? 1 : 0;
				} else {
					segment.requiresAirportChange = trip?.changeOfAirport?.includes(completeSegment.id) ? 1 : 0;
				}

				requiresAirportChange = segment.requiresAirportChange;
				currentTimeOfFlight += completeSegment.traveltime;

				if (['long', 'short'].includes(segment.waitingTimeStatus)) {
					waitingTimeStatus = segment.waitingTimeStatus;
				}

				if (longestSegment.traveltime < completeSegment.traveltime) {
					longestSegment.traveltime = completeSegment.traveltime;
					longestSegment.flight = completeSegment.flight;
				}

				const departureDate = dateParseISO(completeSegment.departureDate);
				const arrivalDate = dateParseISO(completeSegment.arrivalDate);

				segment.localizedDepartureDayString = dateFormat(departureDate, 'PPP');
				segment.localizedArrivalDayString = dateFormat(arrivalDate, 'PPP');
				segment.localizedDepartureDayShortString = dateFormat(departureDate, 'PP');
				segment.localizedArrivalDayShortString = dateFormat(arrivalDate, 'PP');

				if (i < noOfSegs - 1) {
					const nextSegment = trip.segments[i + 1];
					const arrivalTimestamp = parseInt(arrivalDate.getTime());
					const departureTimestamp = parseInt(dateParseISO(nextSegment.departureDate).getTime());
					const waitingTimeSeconds = (departureTimestamp - arrivalTimestamp) / 1000;

					segment.waitTime = getTimeText(waitingTimeSeconds);

					totalWaitingTime += waitingTimeSeconds;

					flightWaitingStops.push({
						airport: completeSegment.arrivalAirport,
						length: segment.waitTime,
						percent: Math.round((currentTimeOfFlight / trip.traveltime) * 100)
					});

					++flightStopsCount;

					currentTimeOfFlight += waitingTimeSeconds;

					tripText = tripText === '' ? completeSegment.arrivalAirport + ': ' + segment.waitTime : '';
				}

				segment.airlineCode = completeSegment.flight.substr(0, 2);

				if (resultsRender.response.airportDetails) {
					segment.departureCity = resultsRender.response.airportDetails?.[completeSegment.departureAirport]?.city || '';
					segment.arrivalCity = resultsRender.response.airportDetails?.[completeSegment.arrivalAirport]?.city || '';
				}

				tripWithMeta.segment[i] = segment;
			}
		}

		tripWithMeta.totalWaitingTime = totalWaitingTime;
		tripWithMeta.totalWaitingTimeText = getTimeText(totalWaitingTime);
		tripWithMeta.airlineCode = longestSegment.flight.substr(0, 2);
		tripWithMeta.airline = this.getAirline(longestSegment.flight);
		tripWithMeta.isAirlinePictureMissing = resultsRender.response?.airlineMissingPictures?.indexOf(tripWithMeta.airlineCode) > -1;
		// tripWithMeta.unmetClassType = resultsRender.response?.unmetClassType;
		tripWithMeta.waitingTimeStatus = waitingTimeStatus;
		tripWithMeta.requiresAirportChange = requiresAirportChange;
		tripWithMeta.waiting = {
			airports: flightWaitingStops,
			stops: flightStopsCount,
			tripText: tripText
		};

		return tripWithMeta;
	},
	getFlights (flights) {
		return flights.map((flight) => {
			flight.trips = this.getTripsAndSegmentsForFlight(flight);
			return flight;
		});
	},
	getTripsAndSegmentsForFlight (flight) {
		// If flights trips is an object it has already been processed
		if (typeof flight.trips?.[0] === 'object') {
			return flight.trips;
		}

		// Otherwise we need to process it
		return flight.trips.map((tripId) => {
			const trip = { ...resultsRender.response.trips[tripId] };
			trip.segments = trip.segments.map(segmentId => resultsRender.response.segments[segmentId]);
			return trip;
		});
	},
	/**
	 * @param {import('../pages/showresult').flight} flight
	 * @param {Number} index
	 * @param {Boolean} processAgents
	 * @returns {Object}
	 */
	getFlightRenderData (flight, index, processAgents = true, source = 'list') {
		if (!flight) {
			throw new Error(`Undefined flight object passed as argument: ${flight} at index: ${index}`);
		}

		// Checking if the flight is processed already, we should try to come up with a more robust solution
		if (flight?.resultIndex != null) {
			return flight;
		}

		let flightData = {};

		if (flight.agents?.length) {
			flightData = {
				...flight,
				formatedPrice: lc(flight.agents[0].price, true),
				// Force cabin to 4 if unmet class type is present
				cabin: flight?.cabin ?? js_params.classType,
				resultIndex: index,
				shared: this.isSharedResultView && flight.orgIndex === js_params.sharedOrgIndex,
				source: source,
				trips: this.getTripsAndSegmentsForFlight(flight)
			};

			flightData.trips = flightData.trips.map((trip, tripIndex) => this.getAlternative(trip, tripIndex));

			flightData.hashes = flightData.trips.map(({ hash }) => hash);

			// Flatten all segments once
			const allSegments = flightData.trips.flatMap(({ segment }) => segment);

			// Determine if any segment has an unmet class type and force cabin to 4
			const hasUnmetClass = allSegments.some(s => s.unmetClassType);
			if (hasUnmetClass) {
				flightData.cabin = 4;
			}

			flightData.airlines = joinWithAmp(Array.from(new Set(allSegments.map(({ airline }) => airline))));

			if (index === 0 && this.searchParams.sorting === 'bestValue' && 'promoted' in flight) {
				const bestValue = this.getPromotedValue(flight.promotedProduct);
				flightData.bestValue = bestValue;
			}

			if ('promotedAgent' in flight) {
				flightData.promotedAgent = flight.promotedAgent;

				if ('promotedProduct' in flight) {
					flightData.promotedProduct = flight.promotedProduct;
				}

				if (processAgents) {
					this.processAgentsRenderingOrder(flightData);
				}
			}

			flightData.ariaLabel = this.formatFlightDetails(flightData);

			this.setSafariTravelPartnerLinks(flightData);
		} else {
			flightData = {
				id: flight.id,
				ancient: true,
				trips: flight.trips,
				index: index
			};
		}

		return flightData;
	},
	formatFlightDetails (tripData) {
		const trip = tripData.trips[0];
		const agents = tripData.agents;

		const mainAgent = agents[0];
		const formattedPrice = mainAgent ? `${mainAgent.price} kr` : 'Price not available';

		const totalTravelTime = trip.totalTravelTime;

		// Main Details
		const summary = `Price: ${formattedPrice}. Total travel time: ${totalTravelTime}.`;

		// Breakdown of each leg
		const segmentDetails = trip.segment.map((segment, index) => {
			const departureInfo = `Depart from ${segment.departureCity} (${segment.departureAirport}) on ${segment.localizedDepartureDayString} at ${segment.departureTime}.`;
			const arrivalInfo = `Arrive in ${segment.arrivalCity} (${segment.arrivalAirport}) on ${segment.localizedArrivalDayString} at ${segment.arrivalTime}.`;

			let layoverInfo = '';
			if (index < trip.segment.length - 1) {
				layoverInfo = `Layover at ${segment.arrivalCity} for ${segment.waitTime}.`;
			}

			return `${departureInfo} ${arrivalInfo} ${layoverInfo}`;
		}).join(' ');


		// Generate full text
		const fullText = `${summary} ${segmentDetails}`;

		return fullText;
	},
	/**
	 * @param {String} datetime - Example: "2022-03-08 12:00"
	 * @returns {String} - Example: "12:00"
	 */
	getDisplayTime (datetime) {
		// in order to show local time independently from timezones
		return datetime.split(' ')?.[1] || '';
	},
	/**
	 * @param {"baggage" | "climateCompensated" | "rebookable"} product
	 */
	getPromotedValue (product) {
		switch (product) {
			case 'baggage':
				return 'baggageIncluded';
			case 'cabinBaggage':
				return 'cabinBaggageIncluded';
			case 'climateCompensated':
				return 'carbonOffset';
			case 'rebookable':
				return 'flexTicket';
		}
	},
	/**
	 *
	 * @param {import('../pages/showresult').flight} flight
	 * @param {Number} index
	 * @returns {Object}
	 */
	getReturnTripSegment (flight, index) {
		const arr = [];
		const j = flight.trips[index].length;
		for (let i = 0; i < j; ++i) {
			arr.push(this.getAlternative(flight, index, i));
		}

		return arr;
	},
	/**
	 * @param {import('../pages/showresult').flight} flight
	 * @param {Number} index
	 * @param {Object} options
	 * @returns
	 */
	getRowHtml (flight, index, options = {}) {
		const journeys = this.getFlightRenderData(flight, index);

		const html = renderJourneys([journeys], {
			filters: this.searchParams.filters,
			showEmissions: this.isEmissionSorting || this.isClimateCompensatedFiltered,
			filteredByClimateCompensation: this.isClimateCompensatedFiltered,
			displayFavBtn: true,
			...(js_params.passengers > 1 ? { multiplePassengers: js_params.passengers } : {}),
			...options
		});

		return html;
	},
	/**
	 * @param {String} agent
	 * @returns {Boolean}
	 */
	isBestAgent (agent) {
		return agent === 'booking';
	},
	/**
	 * @param {String} agent
	 * @returns {Boolean}
	 */
	isDirectBookingAgent (agent) {
		return agent === 'travelpartner';
	},
	/**
	 * @param {flight} flight
	 */
	outclickAgencyResult (flight, tripIndex = 0, eventId) {
		try {
			const agent = flight.agents[tripIndex];

			const showresultID = js_params.urlVars.id;
			const OTA = agent.agent;
			const price = agent.price;

			const recommendedArrayRightToLeft = flight.agents.map(agent => agent.recommended);

			const peopleCount = js_params.passengers;
			const trips = [];
			const airlines = [];

			const trip = resultsRender.getTripsAndSegmentsForFlight(flight);

			trip.forEach((trip) => {
				const tripRes = [];

				trip.segments.forEach((segment) => {
					tripRes.push(segment.departureAirport);
					tripRes.push(segment.arrivalAirport);

					airlines.push(segment.flight.substr(0, 2));
				});

				trips.push(tripRes);
			});

			trackEvent.fakeEcommerce(showresultID, tripIndex, OTA, price, recommendedArrayRightToLeft, peopleCount, airlines, trips, eventId);
		} catch (e) {
			console.log(e);
		}
	},
	/**
	 * Modifies a flight object's agents
	 * @param {Object} flight - processed flight (return value from getFlightData)
	 * @returns {Object} flight
	 */
	processAgentsRenderingOrder (flight) {
		const agentNames = flight.agents.map(item => item.agent);
		const hasPromotedAgent = 'promotedAgent' in flight;

		if (hasPromotedAgent) {
			const promotedAgent = flight.promotedAgent;
			const indexPromoted = this.searchParams.sorting === 'bestValue' && 'promoted' in flight
				? 0
				: agentNames.indexOf(promotedAgent);
			const isPromotedAgentProcessed = agentNames.filter(agent => promotedAgent === agent).length > 1;

			if (!isPromotedAgentProcessed && indexPromoted >= 0 && 'promotedProduct' in flight) {
				flight.agents[indexPromoted].promotedProduct = flight.promotedProduct;

				if ('promoted' in flight) {
					flight.agents[0].promoted = flight.promoted;
				} else {
					flight.agents.splice(1, 0, flight.agents[indexPromoted]);
					if (this.isBestAgent(promotedAgent) || this.isDirectBookingAgent(promotedAgent)) {
						flight.agents.splice(indexPromoted + 1, 1);
					}
				}
			}
		}

		return flight;
	},
	/**
	 * @param {import('../pages/showresult').flight} results
	 * @param {Number} page
	 * @param {Element} renderTarget
	 */
	render (flights, page, renderTarget = qs('#results-container'), source = 'list', templateOptions = {}) {
		const journeys = [];
		const options = {
			filters: window.showresult.searchParams.filters,
			showEmissions: this.isEmissionSorting || this.isClimateCompensatedFiltered,
			filteredByClimateCompensation: this.isClimateCompensatedFiltered,
			displayFavBtn: true,
			...(js_params.passengers > 1 ? { multiplePassengers: js_params.passengers } : {}),
			...templateOptions
		};

		// Parse flights
		const sharedResultJourney = [];
		for (let i = 0; i < flights.length; i++) {
			const parsedFlight = this.getFlightRenderData(flights[i], i + (resultsRender.response.flights.length - flights.length), true, source);
			journeys.push(parsedFlight);
			if (parsedFlight.shared) {
				sharedResultJourney.push(parsedFlight);
			}
		}

		// Generate html
		const html = renderJourneys(journeys, options);

		// Render DOM
		if (page > 0) {
			renderTarget.insertAdjacentHTML('beforeend', html);
		} else {
			renderTarget.innerHTML = html;
		}

		// Render share result
		if (this.isSharedResultView && page === 0) {
			if (sharedResultJourney.length === 0) {
				this.elems.sharedResult.innerHTML = `<div class="sharedResult__msg">${l('showresult.share.filteredOut')}</div>`;
			} else {
				this.elems.sharedResult.innerHTML = renderJourneys(sharedResultJourney, { ...options, shared: true });
			}
		}
	},
	/**
	 *
	 * @param {Number} index
	 * @param {Element} clickedResult
	 */
	renderResultDetails (index, clickedResult) {
		const filtered = resultsRender.response.flights;
		const journey = this.getFlightRenderData(filtered[index], index, false);
		const journeys = [journey];
		const filters = this.searchParams.filter || {};

		const options = {
			filters: filters,
			filteredByClimateCompensation: resultsRender.isClimateCompensatedFiltered,
			showEmissions: resultsRender.isEmissionSorting || resultsRender.isClimateCompensatedFiltered
		};

		const html = renderModal(journeys, options);

		clickedResult.classList.add('abResult--expanded');

		return html;
	},
	/**
	 * @param {Object} data
	 * @param {Object} searchParams
	 */
	setData (data, searchParams = { filters: {} }) {
		resultsRender.response = data;
		this.searchParams = searchParams;
	},
	/**
	 * Modifies flightData.agents with a patched bookingUrl
	 * @param {Object} flightData - processed flight (return value from getFlightData)
	 */
	setSafariTravelPartnerLinks (flightData) {
		if (!isSafari()) {
			return;
		}

		for (let i = 0; i < flightData.agents.length; i++) {
			if (this.isDirectBookingAgent(flightData.agents[i].agent)) {
				const url = encodeURIComponent(Base64.encode(`${document.location.origin}${flightData.agents[i].bookingUrl}`));

				flightData.agents[i].bookingUrl = `${js_params.travelpartnerSafariBounce}?url=${url}`;
			}
		}
	},

	getShowresultUrl (searchID, sorting = getUrlVars()?.sorting) {
		let url = `${location.origin}/${lLink('global.navigation.resultsLink')}?id=${searchID}`;

		if (sorting) {
			url += `&sorting=${sorting}`;
		}
		if (location.href.includes('&filter=')) {
			url += `&filter=${location.href.split('&filter=')[1].split('&')[0]}`;
		}

		return url;
	},

	/**
	 * Creates a new modal instance
	 * @param {int} responseId
	 * @param {object} flight
	 * @param {int} index
	 * @param {object} filters
	 * @param {object} modalOptions
	 * @param {object} handlebarsOptions
	 * @param {string} source
	 * @returns
	 */
	renderModal (responseId, flight, index, filters, modalOptions, options, source = 'list', sorting = getUrlVars()?.sorting) {
		this.searchParams.filters = filters;

		this.resultModal?.close?.();

		// Parse flight
		const journey = this.getFlightRenderData(flight, index, true, source);

		// Generate html
		const html = `<div class="abResult abResult--modal" data-index="${index}">${renderModal([journey], { filters, index, ...options })}</div>`;


		// Open modal
		this.resultModal = new Modal({
			body: html,
			className: 'modal--resultModal',
			footer: `
<button class="js-close-modal abBtn abBtn--whiteBlue abBtn--flex">
	<span>${l('global.simplePhrases.close')}</span>
</button>
<a
	id="price-calendar-show-more-results"
	href="${this.getShowresultUrl(responseId, sorting)}"
	class="abBtn abBtn--blueWhite abBtn--flex">
	<span>${l('global.simplePhrases.showMoreResult')}</span>
</a>`,
			hideHeader: true,
			hideMobileUp: false,
			hideOnSwipe: true,
			hideOnHistoryBack: isMobileView(),
			id: 'resultModal_1',
			onClose: () => {
				// Remove custom event listener.
				// window.removeEventListener('resize', resizeEvent);
				this.resultModal = null;
			},
			// onInit: () => window.addEventListener('resize', resizeEvent),
			resetScroll: true,
			...modalOptions
		});

		return this.resultModal;
	},

	/**
	 * @param {Element} clickedResult
	 */
	async toggleTripDetails (clickedResult) {
		if (clickedResult.closest('#resultModal')) {
			return;
		}

		// Toggle expanded class
		const isExpanded = clickedResult.classList.contains('abResult--expanded');

		// Close previous modal
		if (isExpanded && this?.resultModal?.isOpen) {
			await this.resultModal.close();
		}

		// Get current result trip details
		const resultTripDetails = clickedResult.querySelector('.abResult__flightDetails');

		// Get current index
		const resultIndex = clickedResult.dataset.index;

		// Generate result details preview
		let template = this.renderResultDetails(resultIndex, clickedResult);

		// Render for tablet/desktop.
		if (resultTripDetails.children.length === 0) {
			resultTripDetails.innerHTML = template;
		}

		// Render modal for mobile.
		if (this.resultModal) {
			await this.resultModal.close();
			this.resultModal = null;
		}

		template = `<div class="abResult abResult--modal" data-index="${resultIndex}">${template}</div>`;

		this.buildResultModal(template, resultIndex).open();
	},

	// Share link functions
	/**
	 *
	 * @param {Number} resultIndex
	 * @returns
	 */
	getSharedResultURL (resultIndex) {
		const { orgIndex, lowestprice } = resultsRender.response.flights[resultIndex];
		return setUrlParameter(window.location.href, 'shared', `${orgIndex}-${lowestprice}`);
	},

	/**
	 *
	 * @param {Element} shareBtn
	 * @param {String} sharedURL
	 */
	openManualCopyPopup (shareBtn, sharedURL) {
		const popup = shareBtn.querySelector('.shareBtn__popup');
		popup.classList.add('shareBtn--manualCopy');
		if (popup.innerHTML === '') {
			popup.innerHTML = `<div class="popup__title">${l('showresult.share.manualCopyTitle')}</div><input type="url" class="sharedUrl__field" value="${sharedURL}">`;
		}
		shareBtn.classList.add('popup--visible');
	},

	removeSharedResult () {
		// Update URL
		urlParameterDelete('shared');

		// Remove shared result from DOM
		this.elems.sharedResultContainer.remove();

		this.isSharedResultView = false;
		delete this.searchParams.sharedOrgIndex;
		EventDispatcher.dispatch('updateResults', { source: 'list', params: this.searchParams });
		document.body.classList.remove('shared-result');
	},
	init () {
		if (this.initialised) {
			return;
		}
		this.initialised = true;

		resultsRender.bindEvents();
	}

};

window.resultsRender = resultsRender;

function joinWithAmp (arr) {
	if (arr.length <= 1) {
		return arr[0] || '';
	}
	return arr.slice(0, -1).join(', ') + ' & ' + arr[arr.length - 1];
}
